export const products = {
  title: 'إدارة المنتجات',
  searchPlaceholder: 'البحث عن منتجات...',
  columns: {
    barcode: 'المرجع',
    category: 'الفئة',
    name: 'التسمية',
    description: 'الوصف',
    price: 'السعر بالدرهم',
    cost: 'التكلفة',
    stock: 'المخزون',
    isService: 'النوع',
    image: 'الصورة',
    isActive: 'الحالة',
    tauxTva: 'الضريبة',
    unite: 'الوحدة',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'آخر تعديل',
    lastSync: 'آخر مزامنة',
    packItems: 'عناصر الحزمة',
    modeleVenteId: 'نموذج البيع',
    // أقسام للأعمدة القابلة للطي
    basicInfo: 'المعلومات الأساسية',
    financialInfo: 'التفاصيل المالية',
    systemInfo: 'معلومات النظام'
  },
  filters: {
    search: {
      label: 'بحث',
      placeholder: 'البحث بالاسم، المرجع...'
    },
    sort: {
      label: 'ترتيب حسب',
      placeholder: 'اختر حقل',
      directions: {
        asc: 'تصاعدي',
        desc: 'تنازلي'
      }
    },
    category: {
      label: 'الفئة',
      allCategories: 'جميع الفئات'
    },
    type: {
      label: 'النوع',
      all: 'جميع الأنواع',
      product: 'منتج',
      service: 'خدمة',
      pack: 'حزمة',
      matiere_premiere: 'مادة أولية',
      piece_detachee: 'قطعة غيار'
    },
    priceRange: {
      label: 'نطاق السعر',
      allPrices: 'جميع الأسعار',
      ranges: {
        '0-100': '0 - 100 درهم',
        '100-500': '100 - 500 درهم',
        '500+': '500+ درهم'
      }
    },
    stockStatus: {
      label: 'حالة المخزون',
      all: 'الكل',
      inStock: 'متوفر',
      lowStock: 'مخزون منخفض',
      outOfStock: 'نفذ المخزون'
    },
    dateRange: {
      label: 'الفترة',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية'
    }
  },
  actions: {
    newProduct: 'منتج جديد',
    delete: 'حذف'
  },
  pagination: {
    totalItems: 'إجمالي العناصر',
    previous: 'السابق',
    next: 'التالي',
    page: 'الصفحة'
  },
  form: {
    createTitle: 'منتج جديد',
    editTitle: 'تعديل المنتج',
    tabs: {
      main: 'المعلومات الأساسية',
      secondary: 'المعلومات الثانوية'
    },
    imageHelp: 'انقر لإضافة صورة',
    fields: {
      barcode: 'المرجع',
      name: 'التسمية',
      category: 'الفئة',
      price: 'السعر',
      cost: 'التكلفة',
      tauxTva: 'نسبة الضريبة',
      stock: 'المخزون',
      isService: 'نوع المنتج',
      image: 'الصورة'
    },
    placeholders: {
      barcode: 'أدخل المرجع',
      name: 'أدخل التسمية',
      category: 'اختر الفئة',
      price: 'أدخل السعر',
      stock: 'أدخل المخزون',
      image: 'اختر صورة'
    },
    buttons: {
      save: 'حفظ',
      cancel: 'إلغاء'
    },
    validations: {
      required: 'هذا الحقل مطلوب',
      number: 'الرجاء إدخال رقم صحيح',
      positive: 'يجب أن يكون الرقم موجباً'
    },
    create: 'إنشاء',
    update: 'تحديث',
    cancel: 'إلغاء',
    submitting: 'جاري الحفظ...'
  },
  confirmations: {
    delete: 'هل أنت متأكد من حذف هذا المنتج؟'
  },
  common: {
    notDefined: 'غير محدد'
  },
  units: {
    piece: 'قطعة',
    kg: 'كيلوغرام',
    g: 'غرام',
    l: 'لتر',
    ml: 'ملليلتر',
    m: 'متر',
    cm: 'سنتيمتر',
    m2: 'متر مربع',
    m3: 'متر مكعب',
    h: 'ساعة',
    forfait: 'باقة/خدمة'
  }
}; 